/**
 * Cookie Consent Manager
 * Google Consent Mode v2 uyumlu çerez onay sistemi
 */

const CookieConsent = (() => {
    const STORAGE_KEY = 'Menta_CookieConsent';
    const CONSENT_TYPE = 5; // ConsentType.CookiePolicy
    const BANNER_ID = 'cookie-consent-banner';
    const API_ENDPOINT = '/api/Public/Consent/Submit';

    /**
     * localStorage'dan onay durumunu kontrol et
     */
    function getConsentStatus() {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored !== null ? JSON.parse(stored) : null;
    }

    /**
     * Google Consent Mode ve Meta Consent'i güncelle (İzin verildi)
     */
    function grantConsent() {
        window.dataLayer = window.dataLayer || [];
        
        // Google Consent Mode v2 - Pazarlama ve Analiz izinlerini güncelle
        if (typeof gtag === 'function') {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
        }

        // Meta Pixel Consent Grant
        if (typeof fbq === 'function') {
            fbq('consent', 'grant');
        }

        // dataLayer Event Push
        window.dataLayer.push({
            'event': 'cookie_consent_granted',
            'consent_ad_storage': 'granted',
            'consent_analytics_storage': 'granted',
            'consent_ad_user_data': 'granted',
            'consent_ad_personalization': 'granted'
        });
    }

    /**
     * Google Consent Mode ve Meta Consent'i reddet durumuna getir (İzin verilmedi)
     */
    function denyConsent() {
        window.dataLayer = window.dataLayer || [];
        
        // Google Consent Mode v2 - Pazarlama ve Analiz izinlerini reddet
        if (typeof gtag === 'function') {
            gtag('consent', 'update', {
                'ad_storage': 'denied',
                'analytics_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            });
        }

        // Meta Pixel Consent Revoke (Pazarlama etiketlerini durdur)
        if (typeof fbq === 'function') {
            fbq('consent', 'revoke');
        }

        // dataLayer Event Push
        window.dataLayer.push({
            'event': 'cookie_consent_denied',
            'consent_ad_storage': 'denied',
            'consent_analytics_storage': 'denied',
            'consent_ad_user_data': 'denied',
            'consent_ad_personalization': 'denied'
        });
    }

    /**
     * Onayı localStorage'a kaydet
     */
    function saveConsent(accepted) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(accepted));
    }

    /**
     * API'ye onay gönder (yalnızca giriş yapmış kullanıcılar için)
     */
    async function submitToApi(accepted) {
        try {
            const response = await fetch(API_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Type: CONSENT_TYPE,
                    Accepted: accepted
                })
            });

            if (!response.ok) {
                console.warn('Consent API yanıtı başarısız:', response.status);
            }
        } catch (error) {
            console.error('Consent API hatası:', error);
        }
    }

    /**
     * Banner'ı kapat
     */
    function closeBanner() {
        const banner = document.getElementById(BANNER_ID);
        if (banner) {
            banner.classList.add('opacity-0', 'translate-y-10', 'pointer-events-none');
        }
    }

    /**
     * Banner'ı göster
     */
    function showBanner() {
        const banner = document.getElementById(BANNER_ID);
        if (banner) {
            // Küçük bir gecikme ile göstererek animasyonun tetiklenmesini sağla
            setTimeout(() => {
                banner.classList.remove('opacity-0', 'translate-y-10', 'pointer-events-none');
            }, 500);
        }
    }

    /**
     * "Kabul Et" butonu tıklandığında
     */
    function handleAccept() {
        saveConsent(true);
        grantConsent();
        submitToApi(true);
        closeBanner();
    }

    /**
     * "Reddet" butonu tıklandığında
     */
    function handleReject() {
        saveConsent(false);
        denyConsent();
        submitToApi(false);
        closeBanner();
    }

    /**
     * Sayfa yüklendiğinde kontrol et
     */
    function init() {
        const consentStatus = getConsentStatus();

        if (consentStatus === null) {
            // Onay durumu yok, varsayılan denied olarak banner göster
            denyConsent();
            showBanner();
        } else if (consentStatus === true) {
            // Kullanıcı daha önce kabul etmiş
            grantConsent();
        } else if (consentStatus === false) {
            // Kullanıcı daha önce reddetmiş
            denyConsent();
        }

        // Event listener'ları bağla
        const acceptBtn = document.getElementById('cookie-consent-accept');
        const rejectBtn = document.getElementById('cookie-consent-reject');

        if (acceptBtn) {
            acceptBtn.addEventListener('click', handleAccept);
        }

        if (rejectBtn) {
            rejectBtn.addEventListener('click', handleReject);
        }
    }

    return {
        init
    };
})();

// Sayfa yüklendiğinde çalıştır
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', CookieConsent.init);
} else {
    CookieConsent.init();
}
